import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { KeyValueBlockModule } from "ngx-zcs-components";
import { MatIconModule } from '@angular/material/icon';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { GenericDeviceDashboardComponent } from './generic-device-dashboard.component';

@NgModule({
  declarations: [
    GenericDeviceDashboardComponent,
  ],
  exports: [
    GenericDeviceDashboardComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    KeyValueBlockModule,
    MatIconModule,
  ]
})
export class GenericDeviceDashboardModule { }
